import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useTranslation } from "react-i18next";

function ActiveEnergyPie({ importVal = 0, exportVal = 0 }) {
    const { t } = useTranslation();
    const realImport = Math.trunc((importVal || 0) * 1000) / 1000;
    const realExport = Math.trunc((exportVal || 0) * 1000) / 1000;


    const drawImport = realImport > 0 ? realImport : 0.001;
    const drawExport = realExport > 0 ? realExport : 0.001;

    const data = [
        { name: t('dashboard.importActive'), value: drawImport },
        { name: t('dashboard.exportActive'), value: drawExport },
    ];

    const COLORS = ["#10B981", "#F59E0B"];

    return (
        <div className="bg-white border rounded-xl shadow-sm p-5">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.activeEnergyDist')}
            </h3>

            <div className="flex items-center justify-center h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie data={data} cx="50%" cy="50%" outerRadius={100} dataKey="value">
                            {data.map((_, i) => (
                                <Cell key={i} fill={COLORS[i]} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(v, _, item) => `${Number(item.payload.value).toFixed(3)} kWh`} />
                        <Legend
                            layout="horizontal"
                            align="center"
                            verticalAlign="bottom"
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default ActiveEnergyPie;
